import { axios } from '@/plugins/axios';
import { ICustomerData } from '@/models/customer';
import { ICustomerPricingData } from '@/models';
import { ICustomerActivityData } from '@/models/customeractivity';
import {
  ICustomerFilterParams,
  ICustomerPaginatedListData
} from './customer-service.types';

export class CustomerService {
  private endpoint: string;

  constructor() {
    this.endpoint = 'v1/csi/customers/';
  }

  async createCustomer(customer: ICustomerData) {
    return axios
      .post<ICustomerData>(`${this.endpoint}`, customer)
      .then(({ data }) => data);
  }

  async fetchCustomers(page = 1, filters?: ICustomerFilterParams) {
    return axios
      .get<ICustomerPaginatedListData>(`${this.endpoint}`, {
        params: {
          page: page,
          ...filters
        }
      })
      .then(({ data }) => data);
  }

  async fetchCustomer(id: string) {
    return axios
      .get<ICustomerData>(`${this.endpoint}${id}/`)
      .then(({ data }) => data);
  }

  async updateCustomer(customer: ICustomerData) {
    return axios
      .patch<ICustomerData>(`${this.endpoint}${customer.id}/`, customer)
      .then(({ data }) => data);
  }

  async deleteCustomer(id: string) {
    return axios.delete(`${this.endpoint}${id}/`);
  }

  async addCustomerPricing(snapshot: ICustomerPricingData) {
    return axios
      .post<ICustomerPricingData>(
        `${this.endpoint}${snapshot.customer}/contracts/`,
        snapshot
      )
      .then(({ data }) => data);
  }

  async updateCustomerPricingValidity(snapshot: ICustomerPricingData) {
    return axios
      .put<ICustomerPricingData>(
        `${this.endpoint}${snapshot.customer}/contracts/${snapshot.id}/validity/`,
        { validity: snapshot.validity }
      )
      .then(({ data }) => data);
  }

  async deleteCustomerPricing(snapshot: ICustomerPricingData) {
    return axios.delete(
      `${this.endpoint}${snapshot.customer}/contracts/${snapshot.id}/`
    );
  }

  async fetchCustomerPricingHistory(customerId: string) {
    return axios
      .get<ICustomerActivityData[]>(`${this.endpoint}${customerId}/activities/`)
      .then(({ data }) => data);
  }

  async uploadCustomer(file_upload: FormData) {
    return axios.post(`${this.endpoint}upload_file/`, file_upload, {
      timeout: 10 * (60 * 1000) //10 minutes
    });
  }

  async uploadCustomerAddress(file_upload: FormData) {
    return axios.post(`${this.endpoint}address/upload_file/`, file_upload, {
      timeout: 10 * (60 * 1000) //10 minutes
    });
  }
}
